import { graphql, useStaticQuery } from 'gatsby';
import get from 'lodash.get';
import PropTypes from 'prop-types';
import React from 'react';

import Seo from '../seo';

function LearningCenterSeo({ meta = {}, slug, skipQualified = true }) {
  const { site, siteSettings } = useStaticQuery(
    graphql`
      query {
        site {
          siteMetadata {
            title
            description
            author
          }
        }
        siteSettings: contentfulBlogSettings(contentful_id: { eq: "7xoFud2fVco33HITW3mqY3" }) {
          ...SiteSettings
        }
      }
    `
  );
  const pageTitle = get(meta, 'pageTitle') || get(siteSettings, 'siteMeta.pageTitle') || site.siteMetadata.title;
  const metaDescription =
    get(meta, 'metaDescription.metaDescription') ||
    get(siteSettings, 'siteMeta.metaDescription.metaDescription') ||
    site.siteMetadata.description;

  const metaOgImageUrl = get(meta, 'ogImage.file.url') || get(siteSettings, 'siteMeta.ogImage.file.url', '');
  const metaOgImageTitle = get(meta, 'ogImage.description') || get(meta, 'ogImage.title');
  const isNoFollow = get(meta, 'noFollow[0]');

  return (
    <Seo
      title={pageTitle}
      noFollow={isNoFollow === 'Yes'}
      description={metaDescription}
      ogImageUrl={metaOgImageUrl}
      ogImageAlt={metaOgImageTitle}
      slug={slug}
      skipQualified={skipQualified}
    />
  );
}

LearningCenterSeo.propTypes = {
  meta: PropTypes.shape({
    metaDescription: PropTypes.object,
    pageTitle: PropTypes.string,
    ogImage: PropTypes.object,
    noFollow: PropTypes.array,
  }),
};

export default LearningCenterSeo;
